import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClPassword } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-password',
    templateUrl: './form-password.component.html',
    styleUrls: ['./form-password.component.css'],
    imports: [ReactiveFormsModule, ClPassword, ErrorComponent],
})
export class FormPasswordComponent {
    readonly control = input.required<FormControl<string>>();
    readonly label = input.required<string>();
    readonly placeholder = input<string>('');
    readonly inputId = input.required<string>();
    readonly autocomplete = input<'new-password' | 'current-password'>('new-password');
}
